import { Logger } from '@long-game/common';
export const dndLogger = new Logger('dnd');
//# sourceMappingURL=logger.js.map